import type { PaymentsMessageId } from "./payments.fr";

/** Paiements in Arabic. Same keys and {placeholders} as payments.fr.ts. */
export const paymentsAr: Record<PaymentsMessageId, string> = {
  "payments.tab.payments": "المدفوعات",
  "payments.tab.approvals": "طلبات الموافقة",
  "payments.pick": "اختر دفعة من القائمة.",
  "payments.loading": "جارٍ تحميل الدفعة…",
  "payments.loadFailed": "تعذّر تحميل هذه الدفعة.",
  "payments.notFound": "هذه الدفعة غير موجودة. أعد تحميل القائمة.",
  "payments.refreshFailed": "تعذّر تحديث الدفعة: تُعرض كما كانت.",

  "payments.filter.provider": "وسيلة الدفع",
  "payments.filter.status": "الحالة",
  "payments.filter.all": "الكل",
  "payments.filter.from": "من",
  "payments.filter.to": "إلى",
  "payments.filter.duplicates": "تكرارات محتملة",
  "payments.filter.clearPro": "كل المحترفين",
  "payments.list.loading": "جارٍ تحميل المدفوعات…",
  "payments.list.loadFailed": "تعذّر تحميل المدفوعات.",
  "payments.list.empty": "لا توجد مدفوعات لهذه المرشِّحات.",
  "payments.list.aria": "مدفوعات الرسوم",
  "payments.list.end": "نهاية القائمة",
  "payments.pill.duplicate": "تكرار محتمل",

  "payments.status.pending": "مستحقة الدفع",
  "payments.status.paid": "مدفوعة",
  "payments.status.failed": "فاشلة",
  "payments.status.refunded": "مستردّة",
  "payments.status.waived": "رسوم ملغاة",
  "payments.provider.orange_money": "Orange Money",
  "payments.provider.lengo_pay": "Mobile Money",
  "payments.provider.stripe": "بطاقة (Stripe)",
  "payments.provider.wave": "Wave",
  "payments.feeType.per_job": "رسوم ربط",
  "payments.feeType.monthly": "اشتراك شهري",
  "payments.feeType.yearly": "اشتراك سنوي",
  "payments.kind.refund": "استرداد",
  "payments.kind.credit": "رصيد",
  "payments.kind.waive": "إلغاء الرسوم",
  "payments.kind.mark_paid": "مُعلَّمة كمدفوعة",

  "payments.detail.versionTitle": "نسخة الدفعة المعروضة: تُرسَل مع كل تصحيح.",
  "payments.detail.duplicate": "تكرار محتمل",
  "payments.detail.duplicateBody":
    "دفعة أخرى من المحترف نفسه، بالمبلغ نفسه، قبل بضع دقائق أو بعدها. تحقق قبل الاسترداد:",
  "payments.detail.pro": "المحترف",
  "payments.detail.proPayments": "مدفوعاته ←",
  "payments.detail.transaction": "المرجع لدى المزوّد",
  "payments.detail.job": "الطلب",
  "payments.detail.refunded": "مستردّ مسبقًا",
  "payments.detail.refundable": "قابل للاسترداد بعد",
  "payments.detail.credit": "رصيد المحترف",
  "payments.detail.adjustments": "التصحيحات",
  "payments.detail.noAdjustments": "لا توجد تصحيحات على هذه الدفعة.",
  "payments.detail.actions": "تصحيح",
  "payments.detail.neverOptimistic":
    "لا يُعرض شيء كمُنجَز قبل ردّ الخادم. الاسترداد الذي لم يردّ عليه المزوّد لا يُعاد إرساله أبدًا.",
  "payments.col.kind": "التصحيح",
  "payments.col.amount": "المبلغ",
  "payments.col.status": "الحالة",
  "payments.col.by": "بواسطة",
  "payments.col.actions": "الإجراءات",

  "payments.adjustment.status.pending": "الحالة غير معروفة، جارٍ التحقق",
  "payments.adjustment.status.done": "مُنجَز",
  "payments.adjustment.status.failed": "رفضه المزوّد",
  "payments.adjustment.status.awaiting_manual_transfer": "تحويل يدوي مطلوب",
  "payments.adjustment.status.awaiting_approval": "بانتظار الموافقة",
  "payments.adjustment.status.rejected": "رفضه المالك",
  "payments.adjustment.outcomeUnknownHint":
    "أُرسل إلى المزوّد دون ردّ. لا يُعاد إرساله أبدًا: تحقق من لوحة تحكم المزوّد، ثم سوِّه.",
  "payments.adjustment.manualHint":
    "لا يوفّر Orange Money استردادًا تلقائيًا: أرسل المال يدويًا، ثم سوِّه بمرجع التحويل.",

  "payments.action.refund": "استرداد",
  "payments.action.credit": "إضافة رصيد",
  "payments.action.waive": "إلغاء الرسوم",
  "payments.action.markPaid": "تعليم كمدفوعة",
  "payments.action.settle": "تسوية",
  "payments.action.approve": "موافقة",
  "payments.action.reject": "رفض",

  "payments.dialog.refund.title": "استرداد · {subject}",
  "payments.dialog.refund.body":
    "يُسجَّل الاسترداد ثم يُرسَل مرة واحدة فقط إلى المزوّد. فوق الحد الأقصى، ينتظر موافقة المالك.",
  "payments.dialog.credit.title": "إضافة رصيد · {subject}",
  "payments.dialog.credit.body": "رصيد يُخصم من الرسوم القادمة للمحترف، بالعملة نفسها.",
  "payments.dialog.waive.title": "إلغاء الرسوم · {subject}",
  "payments.dialog.waive.body": "لم تعد الرسوم مستحقة. فوق الحد الأقصى، ينتظر الإلغاء موافقة المالك.",
  "payments.dialog.markPaid.title": "تعليم كمدفوعة · {subject}",
  "payments.dialog.markPaid.body":
    "فقط بمرجع الدفعة الحقيقية (رسالة SMS من المحترف أو كشف الحساب). المرجع الواحد لا يعلّم إلا دفعة واحدة.",
  "payments.dialog.settle.title": "تسوية الاسترداد · {subject}",
  "payments.dialog.settle.body": "سجّل كيف انتهى الاسترداد، بعد التحقق لدى المزوّد.",
  "payments.dialog.approve.title": "الموافقة على طلب {subject}",
  "payments.dialog.approve.body": "يُطبَّق التصحيح المطلوب فورًا. لا أحد يوافق على طلبه بنفسه.",
  "payments.dialog.reject.title": "رفض طلب {subject}",
  "payments.dialog.reject.body": "لا يُستردّ شيء ولا يُلغى. يُحفظ السبب مع الطلب.",
  "payments.field.amount": "المبلغ ({currency})",
  "payments.field.refundHint": "اتركه فارغًا لاسترداد الكل: {amount}.",
  "payments.field.orangeMoneyReference": "مرجع معاملة Orange Money",
  "payments.field.reference": "المرجع لدى المزوّد",
  "payments.field.referenceHint": "انسخه كاملًا من رسالة SMS أو الكشف: حروف وأرقام و . _ : / -",
  "payments.field.outcome": "النتيجة",
  "payments.field.outcome.done": "أُرسل المال",
  "payments.field.outcome.failed": "فشل الاسترداد",

  "payments.problem.reason": "اكتب سببًا من {min} أحرف على الأقل.",
  "payments.problem.amount": "أدخل مبلغًا أكبر من الصفر، بمنزلتين عشريتين على الأكثر.",
  "payments.problem.tooMuch": "هذا أكثر مما تبقّى قابلًا للاسترداد.",
  "payments.problem.reference": "انسخ المرجع كاملًا: {min} أحرف على الأقل، حروف وأرقام و . _ : / - فقط.",

  "payments.outcome.done": "{kind} بمبلغ {amount}: مُنجَز.",
  "payments.outcome.pending":
    "{kind} بمبلغ {amount}: الحالة غير معروفة، جارٍ التحقق. لن يُعاد إرساله؛ سوِّه بعد التحقق.",
  "payments.outcome.awaiting_manual_transfer": "سُجّل {kind} بمبلغ {amount}: أرسل المال يدويًا، ثم سوِّه بالمرجع.",
  "payments.outcome.awaiting_approval": "{kind} بمبلغ {amount}: فوق ما يمكنك فعله بمفردك، ينتظر موافقة.",
  "payments.outcome.failed": "{kind} بمبلغ {amount} رفضه المزوّد ({failure}). لم يتغيّر شيء.",
  "payments.outcome.rejected": "رُفض {kind} بمبلغ {amount}.",

  "payments.approvals.status.pending": "بانتظار القرار",
  "payments.approvals.status.approved": "موافق عليها",
  "payments.approvals.status.rejected": "مرفوضة",
  "payments.approvals.loading": "جارٍ تحميل الطلبات…",
  "payments.approvals.loadFailed": "تعذّر تحميل طلبات الموافقة.",
  "payments.approvals.empty": "لا توجد طلبات هنا.",
  "payments.approvals.requested": "طلبه {name} بتاريخ {date}",
  "payments.approvals.permission": "الإذن: {permission}",
  "payments.approvals.theirLimit": "حدهم: {amount}",
  "payments.approvals.noPermission": "هذا الشخص لا يملك هذا الإذن.",
  "payments.approvals.noLimitInCurrency": "هذا الشخص بلا حد بهذه العملة.",
  "payments.approvals.openPro": "فتح المحترف ←",
  "payments.approvals.decided": "بتّ فيه {name} بتاريخ {date}",
  "payments.approvals.openPayment": "فتح الدفعة ←",
  "payments.approvals.own": "هذا طلبك: يجب أن يبتّ فيه مالك آخر.",

  "payments.export.month": "الشهر المراد تصديره",
  "payments.export.reason": "السبب (اختياري)",
  "payments.export.button": "تصدير CSV",
  "payments.export.running": "جارٍ التصدير…",
  "payments.export.hint": "مدفوعات الشهر (UTC) للمطابقة، دون هاتف أو بريد إلكتروني. كل تصدير يُسجَّل في سجل التدقيق.",
  "payments.export.done": "نُزّل الملف المُصدَّر. سُجّل في سجل التدقيق.",

  "payments.error.stale": "تغيّرت هذه الدفعة أثناء اطلاعك عليها. أعد تحميلها وتحقق ثم حاول مجددًا.",
  "payments.error.refused": "رُفض التصحيح: لا تتضمن أدوارك الميزة اللازمة. اطلب الوصول من أحد المسؤولين.",
  "payments.error.approvalRefused": "مرفوض: لا يبتّ إلا مالك لديه APPROVE_PAYMENT_REQUESTS، ولا يبتّ أبدًا في طلبه هو.",
  "payments.error.invalid":
    "مرفوض: لم تعد الدفعة في الحالة المطلوبة، أو أن المبلغ يتجاوز ما تبقّى، أو أن المرجع مستخدم مسبقًا. أعد التحميل وتحقق.",
  "payments.error.outcomeUnknown":
    "لا ردّ من الخادم: ربما سُجّل التصحيح. أعد المحاولة: لا يمكن تطبيق النقرة نفسها مرتين.",

  "payments.refused.notRefundable": "مرفوض: لا يمكن استرداد إلا رسوم مدفوعة. أعد تحميل الدفعة.",
  "payments.refused.nothingToRefund":
    "مرفوض: هذه الرسوم مستردّة بالكامل مسبقًا، أو أن الباقي قيد الانتظار. أعد تحميل الدفعة.",
  "payments.refused.refundTooLarge": "مرفوض: المبلغ يتجاوز ما تبقّى للاسترداد من هذه الرسوم.",
  "payments.refused.alreadyAwaitingApproval": "مرفوض: إعفاء من هذه الرسوم ينتظر مالكًا مسبقًا. أعد تحميل الدفعة.",
  "payments.refused.notMarkable": "مرفوض: لا يمكن وسم إلا رسوم معلّقة أو فاشلة بأنها مدفوعة. أعد تحميل الدفعة.",
  "payments.refused.referenceInUse": "مرفوض: مرجع Orange Money هذا دفع رسومًا أخرى مسبقًا. تحقق من المرجع.",
  "payments.refused.referenceRequired": "أدخل مرجع المعاملة.",
  "payments.refused.alreadySettled": "سُوّي هذا الاسترداد للتو. أعد تحميله.",
  "payments.refused.alreadyDecided": "بُتّ في هذا الطلب للتو. أعد تحميل القائمة.",
  "payments.refused.ownRequest": "مرفوض: أنت من قدّم هذا الطلب، لذا يبتّ فيه مالك آخر.",
  "payments.refused.approverNotPermitted": "ليس لديك هذا الإذن لهذا المبلغ، لذا لا يمكنك البتّ فيه. يبتّ فيه شخص آخر.",
  "payments.refused.paymentChanged": "مرفوض: تغيّرت الدفعة منذ الطلب. ارفضه بدلًا من ذلك مع ذكر السبب.",
  "payments.refused.currencyMismatch": "مرفوض: يجب أن يكون الرصيد بعملة الرسوم.",
  "payments.refused.feeOfAnotherPro": "مرفوض: دفع هذه الرسوم محترف آخر.",
  "payments.refused.invalidAmount": "مرفوض: يجب أن يكون المبلغ أكبر من صفر.",
};
